import React, { FC, useEffect, useState } from 'react';

import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';
import translate from '@translate';
import { setLocationParams } from 'src/resources/location/reducer';
import TableSimple from 'src/components/TableSimple';
import { allColumns, rowsKeys } from './constants';
import { TableRowType } from 'src/types/table';
import LaunchIcon from '@mui/icons-material/Launch';
import { useCheckPermission } from 'src/utils/checkPermission';
import TopBlock from './TopBlock';

export interface ConstantsListContainerPropsType {}
const ConstantsListContainer: FC<ConstantsListContainerPropsType> = (props) => {
    const dispatch = useDispatch();

    const constantsCodes = useSelector((state: RootStoreType) => state.constantsCodes.data);

    const [constantsList, setConstantsList] = useState<TableRowType[]>([]);

    const permissionDeatil = useCheckPermission('CONSTATN.DETAIL');

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('constants.title') }));
        setConstantsList(
            rowsKeys.map((key) => ({
                name: key,
                key,
                data: constantsCodes[key],
                count: constantsCodes[key]?.length,
            }))
        );
    }, []);

    return (
        <>
            <TopBlock />
            <TableSimple
                rowIdKey="key"
                rows={constantsList}
                columsLabelPrefix="constants.table"
                allColumns={allColumns}
                initSort={{ column: 'name', direction: 'DESC' }}
                rowActions={[
                    {
                        icon: <LaunchIcon />,
                        label: translate('constants.action.constantDetail'),
                        getLink: (row) => `/admin/constants/${row.key}/`,
                        hiddenFce: () => !permissionDeatil,
                    },
                ]}
                heightVariant="top-tab"
                fullHeight
                optionsSessionName="constantsTable"
            />
        </>
    );
};

export default ConstantsListContainer;
